
import { post } from './index'

export const Routing = {
	fetchVehicleRecommendation: (routes) => post('/routing/vehicle-types', {
		routes
	})
}
